import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NotificationsService } from 'angular2-notifications';
import { FeeColumnFilterPanelService, PlayerAdjustmentService } from '../../../../services';
import { AppState, Store, take, AppFields, Club, StorageUtil, forkJoin } from '../../../../store';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
  selector: 'app-add-credit',
  templateUrl: './add-credit.component.html',
  styleUrls: ['./add-credit.component.css']
})
export class AddCreditComponent implements OnInit {
  public reasons: any[];
  public creditForm: FormGroup;
  public validationMessages = {};

  @Input() userId: number;
  @Input() ClubUserProgramFeeID: string;
  @Input() ClubProgramFeeID: string;
  @Input() clubProgramID: string;
  @Input() members = [];
  @Input() multi: boolean;

  @Output() added = new EventEmitter();
  @Output() close = new EventEmitter();

  constructor(
    private fb: FormBuilder,
    private spinner: Ng4LoadingSpinnerService,
    private notificationsService: NotificationsService,
    private feeColumnFilterPanelService: FeeColumnFilterPanelService,
    private playerAdjustmentService: PlayerAdjustmentService,
    private store: Store<AppState>
  ) {
    this.reasons = [
      { 'key': 'Overpayment', 'value': 'Overpayment' },
      { 'key': 'Registration Issue', 'value': 'Registration Issue' },
      { 'key': 'Sibling Issue', 'value': 'Sibling Issue' },
      { 'key': 'Travel Issue', 'value': 'Travel Issue' },
      { 'key': 'Participation', 'value': 'Participation' },
      { 'key': 'Sponsorship', 'value': 'Sponsorship' },
      { 'key': 'Other', 'value': 'Other' },
    ];
    this.validationMessages = {
      'AmountRequired': 'This field is required.',
      'ReasonRequired': 'Please select an option.'
    };
  }

  ngOnInit() {
    this.initForm();
  }

  initForm() {
    this.creditForm = this.fb.group({
      Amount: ['', [Validators.required]],
      Reason: ['', [Validators.required]],
    });
  }

  isAmountValid() {
    return this.creditForm.get('Amount').errors
      && (this.creditForm.get('Amount').touched
        || this.creditForm.get('Amount').dirty);
  }

  isReasonValid() {
    return this.creditForm.get('Reason').errors
      && (this.creditForm.get('Reason').touched
        || this.creditForm.get('Reason').dirty);
  }

  validateUi() {
    Object.keys(this.creditForm.controls).forEach(field => {
      const control = this.creditForm.get(field);
      control.markAsTouched({ onlySelf: true });
    });
  }

  onSubmit(event, formStatus) {
    event.stopPropagation();
    if (formStatus === 'VALID') {
      this.spinner.show();
      this.store.select(AppFields.App, AppFields.Club).pipe(take(1)).subscribe(
        (club: Club) => {
          if (this.multi) {
            const calls = this.members.map(m => this.playerAdjustmentService.saveTravelCredit({
              clubProgramID: this.clubProgramID,
              Amount: +this.creditForm.value.Amount,
              Reason: this.creditForm.value.Reason,
              AddedBy: StorageUtil.userID,
              UpdatedBy: StorageUtil.userID,
              UserID: m.userID,
              clubID: StorageUtil.clubID
            }));
            forkJoin(calls).subscribe(
              () => {
                event.target.innerHTML = 'Save';
                event.target.disabled = false;
                this.clearFormData();
                this.closeSideOverlay();
                this.alertMessage('success', 'Credit was added successfully');
                this.added.emit();
                this.spinner.hide();
              },
              () => {
                this.spinner.hide();
              }
            );
          } else {
            const obj = {
              ClubUserProgramFeeID: Number(this.ClubUserProgramFeeID),
              Amount: Number(this.creditForm.value.Amount),
              Reason: this.creditForm.value.Reason,
              AddedBy: StorageUtil.userID,
              UpdatedBy: StorageUtil.userID,
              UserID: this.userId,
              clubID: club.clubID
            };
            event.target.innerHTML = 'Saving <i class="fa fa-spinner fa-spin push-5-r"></i>';
            event.target.disabled = true;
            this.playerAdjustmentService.saveCredit(obj).subscribe((data: any) => {
              event.target.innerHTML = 'Save';
              event.target.disabled = false;
              this.clearFormData();
              this.closeSideOverlay();
              this.alertMessage('success', data.result);
              this.spinner.hide();
            }, error => {
              this.alertMessage('error', error.statusText);
              this.spinner.hide();
            });
          }
        }
      );
    } else {
      this.validateUi();
    }
  }

  clearFormData() {
    this.creditForm.reset();
  }

  onReset(event) {
    event.stopPropagation();
    this.clearFormData();
    this.closeSideOverlay();
  }

  closeSideOverlay() {
    this.feeColumnFilterPanelService.setToggleFilterColumnsPanel(false);
    this.close.emit();
  }

  alertMessage(status, message) {
    const toast = this.notificationsService.success(status, message, {
      timeOut: 3000,
      showProgressBar: true,
      pauseOnHover: false,
      clickToClose: false
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/member-billing-info/add-credit/add-credit.component.ts